/* eslint-disable @typescript-eslint/naming-convention */
import React, {
  ChangeEvent,
  useState,
  FormEvent,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Container,
  Grid,
  Paper,
  Box,
  Drawer,
  // Menu,
  MenuItem,
  // Tooltip,
  TextField,
  Select,
  InputAdornment,
  IconButton,
  Button,
  SelectChangeEvent,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import Layout from "../Layout";
import { fetchRequest, updateState } from "../../store/terminal/actions";
import {
  fetchRequest as fetchTerminalApp,
  fetchVersion,
} from "../../store/myAxis/actions";
// import { getNew } from "../../repo/terminal";
import { ApplicationState } from "../../store";
import TerminalTable from "./terminalTable/TerminalTable";
import {
  TerminalTableParams,
  ColumnToRecordMapping,
} from "./terminalTable/TerminalTable";
import PageHeading from "../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
import FilterForm, {
  Entity,
  FilterDataParams,
  FilterFormProps,
} from "../../common/advancedFilter/AdvancedFilter";
import * as Yup from "yup";
import { FormikValues } from "formik";
import { Option } from "../../common/advancedFilter/DynamicField";
import { Data as CustomGroupData } from "../../store/customGroup/types";
import { Data as MerchantData } from "../../store/merchant/types";
import { fetchRequest as fetchCustomGroups } from "../../store/customGroup/actions";
import { isEmpty, isNil } from "ramda";
import CustomizedTooltip from "../../common/toolTip/CustomizedTooltip";
import {
  BulkUpdateData,
} from "../../common/bulkUpdate/BulkUpdate";
import { DynamicFieldProps } from "../../common/bulkUpdate/steps/BulkUpdateData";
import { fetchRequest as fetchCard } from "../../store/card/actions";
import { fetchRequest as fetchEmv } from "../../store/emv/actions";
import {
  bulkUpdateLimit,
  showBulkUpdateButtonTooltip,
} from "../../common/bulkUpdate/bulkUpdateHelper";
import useUserAccess from "../../effects/useUserAccess";
import _, { get } from "lodash";
import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import CloudDownload from "@mui/icons-material/CloudDownload";
import { downloadRequest } from "../../store/terminal/actions";
import { IS_DMG_INSTANCE } from "../../lib/utils";

const terminaTypes = ["A920", "A910", "IM30", "IM25", "A930", "A77", "A920PRO", "DX8000", "QT 850", "NG 850", "Virtual"];

export const downloadLimit = parseInt(process.env.DONWLOAD_LIMIT || "100");

interface Pagination {
  page: {
    limit: string;
    offset: string;
  };
  filter: { [index: string]: string | string[] | Option[] };
  sort: string;
  isStaged?: boolean;
  cache?: string;
}

interface Props {
  environment?: string;
  isStaged?: boolean;
}

interface TerminalBulkEditFields {
  attributes: {
    TID: string;
    TerminalType: string;
    SerNo: string;
    MID: string;
    CPATName: string;
    EMVConfigName: string;
    POIID: string;
  };
}

export default function Terminal({ environment, isStaged }: Props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();
  const access = useUserAccess();
  const urlSearchParams = new URLSearchParams(history.location.search);
  const onboardingId = urlSearchParams.get('onboardingId') as string;

  const [filterQuery, setFilterQuery] = useState<FormikValues>({});
  const filterQueryRefs = useRef({});
  const [isBulkUpdateAvailable, setIsBulkUpdateAvailable] = useState(false);
  // const [isFirstTimeLoad, setFirstTimeLoad] = useState(true);
  let initParams = new TerminalTableParams();
  initParams.type = 'Terminal';
  const [params, setParams] = useState<TerminalTableParams>(
    onboardingId ? {
      ...initParams,
      searchField: 'OnboardingID',
      searchText: onboardingId
    } :  initParams
  );

  useEffect(() => {
    if (onboardingId) {

    }
  })

  const [filterParams, setFilterParams] = useState<FilterDataParams>({
    page: 0,
    pageSize: 10,
    pageCount: 0,
    orderBy: -1,
    orderDirection: "",
    queries: {},
    totalCount: 1,
  });
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  // get data CPAT, EMV, Groups
  const cpat = useSelector((state: ApplicationState) =>
    state.card.data ? state.card.data.data : []
  );
  const emvOptions =
    useSelector((state: ApplicationState) => state.emv.data) ?? [];

  // const onboardedDateOptions =
  //   useSelector((state: ApplicationState) => state.terminal.data) ?? [];

  const myAxisData =
    useSelector((state: ApplicationState) => state.myAxis.versions) ?? {};
  const myAxisNabData = myAxisData["NAB Payment App"]; //extracting myAxis data only for NAB Payment App

  const merchants: MerchantData[] =
    useSelector((state: ApplicationState) => state.merchant.data?.data) ?? [];

  // get all groups from state
  const allGroups =
    (useSelector<ApplicationState>(
      (store) => store.customGroup.data?.data
    ) as CustomGroupData[]) || [];

  useEffect(() => {
    if (isEmpty(allGroups)) {
      dispatch(fetchCustomGroups(null));
    }
    if (isEmpty(cpat)) {
      dispatch(fetchCard(null));
    }
    if (isEmpty(emvOptions)) {
      dispatch(fetchEmv());
    }
    dispatch(
      fetchTerminalApp((applications) => {
        if (Array.isArray(applications)) {
          applications.forEach((appName: string) => {
            dispatch(fetchVersion(appName));
          });
        }
      })
    );
  }, [dispatch]); // Add dispatch as dependency

  // Additional useEffect to ensure data is fetched when store state changes
  useEffect(() => {
    // Re-fetch data if it's empty to ensure dropdowns are populated
    if (isEmpty(emvOptions)) {
      dispatch(fetchEmv());
    }
  }, [emvOptions, dispatch]);

  const filterFields: FilterFormProps = {
    entity: Entity.Terminal,
    sections: [
      {
        name: "Terminal",
        fields: [
          {
            fieldType: "select",
            label: "Terminal Type",
            name: "attributes.TerminalType",
            options: terminaTypes?.map((t) => ({
              label: t,
              value: t,
            })),
          },
          {
            fieldType: process.env.IDP === "NAB" ? "select": "text",
            label: "Software Version",
            name: "attributes.AXISPayVersion",
            options: process.env.IDP === "NAB" ? myAxisNabData?.versions?.map((version) => ({
              label: version,
              value: version,
            })) : ""
          },
          {
            fieldType: "select",
            label: "CPAT Name",
            name: "attributes.CPATName",
            options: cpat?.map((cp) => ({
              label: cp.attributes.Name,
              value: cp.attributes.Name,
            })),
          },
          {
            fieldType: "select",
            label: "EMV",
            name: "attributes.EMVConfigName",
            options: emvOptions.map((emv) => ({
              label: emv.attributes.ConfigName,
              value: emv.attributes.ConfigName,
            })),
          },
          {
            fieldType: "text",
            fullWidth: true,
            label: "Onboarded Date (DD-MM-YYYY)",
            name: "OnboardedDate",
          },
          {
            fieldType: "autocomplete",
            label: "Groups",
            name: "attributes.groups",
            fullWidth: true,
            disabled: !IS_DMG_INSTANCE,
            options:
              allGroups && allGroups.length
                ? allGroups.map((group) => ({
                    label: group.name,
                    value: group.groupId,
                  }))
                : [],
          },
          {
            fieldType: "select",
            label: "DMG Updater version",
            name: 'attributes.Applications.DMG Updater.VersionString',
            options: Array.isArray(get(myAxisData, 'DMG Updater.versions', [])) 
              ? get(myAxisData, 'DMG Updater.versions', []).map(i => ({ label: i, value: i }))
              : [],
          },
          {
            fieldType: "select",
            label: "Satellite version",
            name: 'attributes.Applications.Satellite.VersionString',
            options: Array.isArray(get(myAxisData, 'Satellite.versions', [])) 
              ? get(myAxisData, 'Satellite.versions', []).map(i => ({ label: i, value: i }))
              : [],
          },
          {
            fieldType: "select",
            label: "NAB Payment App version",
            name: 'attributes.Applications.NAB Payment App.VersionString',
            options: Array.isArray(get(myAxisData, 'NAB Payment App.versions', [])) 
              ? get(myAxisData, 'NAB Payment App.versions', []).map(i => ({ label: i, value: i }))
              : [],
          },
          {
            fieldType: "select",
            label: "PayAtTable version",
            name: 'attributes.Applications.PayAtTable.VersionString',
            options: Array.isArray(get(myAxisData, 'PayAtTable.versions', [])) 
              ? get(myAxisData, 'PayAtTable.versions', []).map(i => ({ label: i, value: i }))
              : [],
          },
          {
            fieldType: "select",
            label: "Shadow Meter version",
            name: 'attributes.Applications.Shadow Meter.VersionString',
            options: Array.isArray(get(myAxisData, 'Shadow Meter.versions', [])) 
              ? get(myAxisData, 'Shadow Meter.versions', []).map(i => ({ label: i, value: i }))
              : [],
          }
        ],
      },
    ],
  };

  const handleOnChange = (event: { target: { value: string } }) => {
    setParams({
      ...params,
      searchText: event.target.value,
    });
  };

  useEffect(() => {
    filterQueryRefs.current = {};
    refreshData(params);
  }, [isStaged]);

  const refreshData = (newParams: TerminalTableParams) => {
    const p: Pagination = {
      page: {
        limit: String(newParams.pageSize),
        offset: String(newParams.pageSize * newParams.page),
      },
      filter: { ...filterQueryRefs.current },
      sort: "",
      isStaged: isStaged,
      cache: newParams.cache
    };
    if (newParams.orderBy > -1)
      p.sort =
        (newParams.orderDirection == "desc" ? "-" : "") +
        ColumnToRecordMapping[newParams.orderBy];

    if (newParams.searchText) {
      p.filter[newParams.searchField] = (newParams.searchText || "").trim();
    }

    setParams({ ...newParams });

    dispatch(fetchRequest(null, p));
  };

  // filter data function
  const applyFilterData = (newParams: FilterDataParams) => {
    const p: Pagination = {
      page: {
        limit: String(newParams.pageSize),
        offset: String(newParams.pageSize * newParams.page),
      },
      filter: {},
      sort: "",
      isStaged: isStaged,
    };

    if (newParams.orderBy > -1)
      p.sort =
        (newParams.orderDirection == "desc" ? "-" : "") +
        ColumnToRecordMapping[newParams.orderBy];

    if (newParams.queries) {
      p.filter = newParams.queries;
    }

    setParams({
      ...params,
      pageSize: newParams.pageSize,
      page: newParams.page,
    });
    dispatch(fetchRequest(null, p));
  };

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.terminal
  );
  const terminalsStore = data?.data ?? [];
  const terminalsStoreObjects = data?.meta?.totalObjects ?? 0;
  const [showMerchantDrawer, setShowMerchantDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleAddButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ): void => {
    setAnchorEl(event.currentTarget);
  };

  const onChangePage = (page: number, pageSize: number) => {
    const p = { ...params, pageSize: pageSize, page: page };
    // setParams(p);
    refreshData(p);
  };

  const onSearchChange = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const p = { ...params, page: 0, cache: 'ignore' };
    refreshData(p);
  };

  // const handleAddMenuClose = (): void => {
  //   setAnchorEl(null);
  // };

  const handleUpload = async (
    event: ChangeEvent<HTMLInputElement>
  ): Promise<void> => {
    if (event.currentTarget.files && event.currentTarget.files.length > 0) {
      const file = event.currentTarget.files[0];
      const readFile = new Promise<string>((resolve) => {
        const fileReader = new FileReader();
        fileReader.onload = (event): void => {
          resolve(event.target?.result as string);
        };
        fileReader.readAsText(file);
      });
      let contents = {};
      try {
        contents = JSON.parse(await readFile);
      } catch (e) {
        console.error(e);
      }
      const uploadObj = {
        file: contents,
        name: file.name,
        type: file.type,
      };

      history.push({
        pathname: "/terminalimport",
        state: { uploadObj: uploadObj },
      });
    }
  };

  // const selectedTerminals = terminalsStore.filter(({ selected }) => selected);

  const onFilterSubmit = (filterData: FormikValues) => {
    const p: FilterDataParams = {
      ...filterParams,
      queries: filterData.values,
    };
    applyFilterData(p);
    filterQueryRefs.current = filterData.values;
    setFilterQuery(filterData);
  };

  /** BULK UPDATE FOR TERMINAL **/
  // check bulk update status
  const isBulkUpdateAccessAllowed =
    get(access, `BulkUpdate.Access.U`) && !isStaged;

  useEffect(() => {
    const isAvailable =
      isBulkUpdateAccessAllowed &&
      filterQuery &&
      filterQuery.values &&
      terminalsStoreObjects > 0 &&
      terminalsStoreObjects <= bulkUpdateLimit;

    setIsBulkUpdateAvailable(!!isAvailable);
  }, [terminalsStoreObjects, filterQuery]);

  // define fields to be updated
  const updateFields: DynamicFieldProps[] = [
    {
      fieldType: "text",
      label: "URL Upgrade",
      name: "attributes.URLUpgrade",
      // validationSchema: Yup.string().required(),
    },
    {
      fieldType: "select",
      label: "CPAT Name",
      name: "attributes.CPATName",
      options:
        cpat?.map((cp) => ({
          label: cp.attributes.Name,
          value: cp.attributes.Name,
        })) || [],
    },
    {
      fieldType: "select",
      label: "EMV",
      name: "attributes.EMVConfigName",
      options:
        emvOptions.map((emv) => ({
          label: emv.attributes.ConfigName,
          value: emv.attributes.ConfigName,
        })) || [],
    },
    {
      fieldType: "select",
      label: "DMG Updater version",
      name: "attributes.Applications.DMG Updater.VersionString",
      options: Array.isArray(get(myAxisData, 'DMG Updater.versions', [])) 
        ? get(myAxisData, 'DMG Updater.versions', []).map(i => ({ label: i, value: i }))
        : []
    },
    {
      fieldType: "select",
      label: "Satellite version",
      name: "attributes.Applications.Satellite.VersionString",
      options: Array.isArray(get(myAxisData, 'Satellite.versions', [])) 
        ? get(myAxisData, 'Satellite.versions', []).map(i => ({ label: i, value: i }))
        : []
    },
    {
      fieldType: "select",
      label: "NAB Payment App version",
      name: "attributes.Applications.NAB Payment App.VersionString",
      options: Array.isArray(get(myAxisData, 'NAB Payment App.versions', [])) 
        ? get(myAxisData, 'NAB Payment App.versions', []).map(i => ({ label: i, value: i }))
        : []
    },
    {
      fieldType: "select",
      label: "PayAtTable version",
      name: "attributes.Applications.PayAtTable.VersionString",
      options: Array.isArray(get(myAxisData, 'PayAtTable.versions', [])) 
        ? get(myAxisData, 'PayAtTable.versions', []).map(i => ({ label: i, value: i }))
        : []
    },
    {
      fieldType: "select",
      label: "Shadow Meter version",
      name: "attributes.Applications.Shadow Meter.VersionString",
      options: Array.isArray(get(myAxisData, 'Shadow Meter.versions', [])) 
        ? get(myAxisData, 'Shadow Meter.versions', []).map(i => ({ label: i, value: i }))
        : []
    }
  ];

  const tableColumns = useMemo<MRT_ColumnDef<TerminalBulkEditFields>[]>(
    () => [
      { header: "TID", accessorKey: "attributes.TID", size: 100 },
      {
        header: "Terminal Type",
        accessorKey: "attributes.TerminalType",
        size: 130,
      },
      { header: "Serial No", accessorKey: "attributes.SerNo" },
      { header: "MID", accessorKey: "attributes.MID", size: 80 },
      { header: "CPAT", accessorKey: "attributes.CPATName" },
      { header: "EMV", accessorKey: "attributes.EMVConfigName" },
      { header: "POI Device ID", accessorKey: "attributes.POIID" },
    ],
    []
  );

  const handleBulkUpdate = () => {
    if (
      !isEmpty(filterQuery) &&
      terminalsStoreObjects > 0 &&
      terminalsStoreObjects <= bulkUpdateLimit
    ) {
      const bulkUpdateProps: BulkUpdateData<TerminalBulkEditFields> = {
        pathname: "/bulkUpdate/terminal",
        state: {
          filterQuery: filterQuery,
          updateFields,
          tableColumns,
        },
      };

      history.push(bulkUpdateProps);
    }
  };
  const [isDownloadAvailable, setIsDownloadAvailable] = useState(false);

  useEffect(()=>{
    if ((params.searchText !== '' || !_.isEmpty(filterQuery.values)) && terminalsStoreObjects > 0 && terminalsStoreObjects <= downloadLimit && !isStaged) {
      setIsDownloadAvailable(true);
    } else {
      setIsDownloadAvailable(false);
    }
  },[terminalsStoreObjects]);

  const downloadButtonTooltip = (storeObjects: number, filterQuery, searchText) => {
    if (_.isEmpty(filterQuery?.values) && _.isEmpty(searchText)) {
      return `Filter or search data to use this feature`;
    } else {
      if (storeObjects === 0) {
        return "You have no item to download";
      } else if (storeObjects > downloadLimit) {
        return `You can download max ${downloadLimit} items while you have ${storeObjects} items in filtered data`;
      } else {
        return `Download for ${storeObjects} items below`;
      }
    }
  }

  const handleDownload = () => {
    const p = {
      page: {
        limit: '99999',
        offset: '0',
      },
      filter: { ...filterQueryRefs.current },
      action:"export",
      cache:"ignore",
      header:["TID", "MID", "SerNo", "TerminalType", "OnboardingID","OnboardedDate"],
      excludeFields:["RunningTotals","Processor","TxnCountSinceLastLogin","HTMLReceipts","Processor"],
      sort: "",
    };
    p.filter[params.searchField] = (params.searchText || "").trim();
    dispatch(downloadRequest(p));
  };
  // update table when pagination change
  useEffect(() => {
    onChangePage(pagination.pageIndex, pagination.pageSize);
  }, [pagination.pageIndex, pagination.pageSize]);

  return (
    <Layout sessionData={session} key="terminal">
      <main className={classes.content as string}>
        <div className={classes.appBarSpacer as string} />
        <Container maxWidth="lg" className={classes.container as string}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  heading={isStaged ? "Injected Terminals" : "Terminals"}
                  entity="Terminal"
                ></PageHeading>
              </Paper>
              <Box my={2}>
                <Paper>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="2rem 1rem"
                  >
                    <Box display="flex" width="100%">
                      {!isStaged && (
                        <FilterForm
                          entity={filterFields.entity}
                          sections={filterFields.sections}
                          onSubmit={onFilterSubmit}
                        />
                      )}
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="end"
                      alignItems="center"
                      width="100%"
                    >
                      {/* {isBulkUpdateAccessAllowed ? (
                        <CustomizedTooltip
                          title={showBulkUpdateButtonTooltip(
                            terminalsStoreObjects,
                            filterQuery
                          )}
                        >
                          <Box marginRight={1}>
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={handleBulkUpdate}
                              disabled={!isBulkUpdateAvailable}
                            >
                              Bulk Update
                            </Button>
                          </Box>
                        </CustomizedTooltip>
                      ) : null} */}

                      <form
                        style={{ display: "flex" }}
                        onSubmit={(e) => onSearchChange(e)}
                      >   {/* <CustomizedTooltip
                             title={downloadButtonTooltip(
                             terminalsStoreObjects,
                             filterQuery,
                             params.searchText
                             )}> */}
                              {/* <Box marginRight={1}>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={handleDownload}
                                  disabled={!isDownloadAvailable}
                                  startIcon={<CloudDownload />}
                                >Download</Button>
                              </Box> */}
                            {/* </CustomizedTooltip> */}
                          <Select
                            variant="standard"
                            value={params.searchField}
                            onChange={(event: SelectChangeEvent<string>) => {
                              setParams({
                                ...params,
                                searchField: event.target.value,
                              });
                            }}
                          >
                            <MenuItem value="attributes.TID" selected={true}>
                              Terminal ID
                            </MenuItem>
                            <MenuItem value="attributes.MID">
                              Merchant ID
                            </MenuItem>
                            <MenuItem value="attributes.SerNo">
                              Serial Number
                            </MenuItem>
                            <MenuItem value="attributes.TerminalType">
                              Terminal Type
                            </MenuItem>
                            <MenuItem value="attributes.POIID">POI ID</MenuItem>
                            {/* <MenuItem value="attributes.Shard">Shard</MenuItem> */}
                            <MenuItem value="OnboardingID">Onboarding Request ID</MenuItem>
                          </Select>
                        <TextField
                          style={{ marginTop: "8px", marginLeft: 5, minWidth: "200px", flex: 1 }}
                          placeholder={"Search"}
                          onChange={handleOnChange}
                          value={params.searchText}
                          variant="standard"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  type="submit"
                                  // onClick={onSearchChange}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </form>
                    </Box>
                  </Box>

                  {loading ? (
                    <ProgressIndicator />
                  ) : (
                    <TerminalTable
                      terminal={terminalsStore}
                      terminalCount={terminalsStoreObjects}
                      pagination={pagination}
                      setPagination={setPagination}
                      isStaged={isStaged}
                    />
                  )}
                </Paper>
              </Box>
            </Grid>
          </Grid>
          <Drawer
            anchor="right"
            open={showMerchantDrawer}
            onClose={(): void => setShowMerchantDrawer(false)}
          />
        </Container>
      </main>
    </Layout>
  );
}
